// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import table from './table'
import routes from './routes'
import config from './config'
import steps from './steps'
import product from './product'
import trackandtrace from './trackandtrace'
import passport from './passport'
import form302 from './form302'

const rootReducer = combineReducers({
  config,
  auth,
  navbar,
  layout,
  table,
  routes,
  steps,
  product,
  trackandtrace,
  passport,
  form302
})

export default rootReducer
